/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteSupplier } from '../fn/supplier/delete-supplier';
import { DeleteSupplier$Params } from '../fn/supplier/delete-supplier';
import { SuccessfulResponse as DigiworkMaitreDApiConfigurationModelSuccessfulResponse } from '../models/Digiwork/MaitreD/Api/Configuration/Model/successful-response';
import { SupplierDto as DigiworkMaitreDPosDtoSuppliersSupplierDto } from '../models/Digiwork/MaitreD/Pos/DTO/Suppliers/supplier-dto';
import { SuppliersDto as DigiworkMaitreDPosDtoSuppliersSuppliersDto } from '../models/Digiwork/MaitreD/Pos/DTO/Suppliers/suppliers-dto';
import { getAllSuppliers } from '../fn/supplier/get-all-suppliers';
import { GetAllSuppliers$Params } from '../fn/supplier/get-all-suppliers';
import { getSupplier } from '../fn/supplier/get-supplier';
import { GetSupplier$Params } from '../fn/supplier/get-supplier';
import { newSupplier } from '../fn/supplier/new-supplier';
import { NewSupplier$Params } from '../fn/supplier/new-supplier';
import { updateSupplier } from '../fn/supplier/update-supplier';
import { UpdateSupplier$Params } from '../fn/supplier/update-supplier';

@Injectable({ providedIn: 'root' })
export class SupplierService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllSuppliers()` */
  static readonly GetAllSuppliersPath = '/api/suppliers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSuppliers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSuppliers$Response(params?: GetAllSuppliers$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoSuppliersSuppliersDto>> {
    return getAllSuppliers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllSuppliers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSuppliers(params?: GetAllSuppliers$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoSuppliersSuppliersDto> {
    return this.getAllSuppliers$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoSuppliersSuppliersDto>): DigiworkMaitreDPosDtoSuppliersSuppliersDto => r.body)
    );
  }

  /** Path part for operation `newSupplier()` */
  static readonly NewSupplierPath = '/api/suppliers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newSupplier()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  newSupplier$Response(params?: NewSupplier$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoSuppliersSupplierDto>> {
    return newSupplier(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newSupplier$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  newSupplier(params?: NewSupplier$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoSuppliersSupplierDto> {
    return this.newSupplier$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoSuppliersSupplierDto>): DigiworkMaitreDPosDtoSuppliersSupplierDto => r.body)
    );
  }

  /** Path part for operation `getSupplier()` */
  static readonly GetSupplierPath = '/api/suppliers/{supplierId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSupplier()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSupplier$Response(params: GetSupplier$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoSuppliersSupplierDto>> {
    return getSupplier(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSupplier$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSupplier(params: GetSupplier$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoSuppliersSupplierDto> {
    return this.getSupplier$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoSuppliersSupplierDto>): DigiworkMaitreDPosDtoSuppliersSupplierDto => r.body)
    );
  }

  /** Path part for operation `updateSupplier()` */
  static readonly UpdateSupplierPath = '/api/suppliers/{supplierId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSupplier()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSupplier$Response(params: UpdateSupplier$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoSuppliersSupplierDto>> {
    return updateSupplier(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSupplier$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSupplier(params: UpdateSupplier$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoSuppliersSupplierDto> {
    return this.updateSupplier$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoSuppliersSupplierDto>): DigiworkMaitreDPosDtoSuppliersSupplierDto => r.body)
    );
  }

  /** Path part for operation `deleteSupplier()` */
  static readonly DeleteSupplierPath = '/api/suppliers/{supplierId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSupplier()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSupplier$Response(params: DeleteSupplier$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>> {
    return deleteSupplier(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSupplier$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSupplier(params: DeleteSupplier$Params, context?: HttpContext): Observable<DigiworkMaitreDApiConfigurationModelSuccessfulResponse> {
    return this.deleteSupplier$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>): DigiworkMaitreDApiConfigurationModelSuccessfulResponse => r.body)
    );
  }

}
